import React, { useState } from 'react';
import clsx from 'clsx';
import { Copy, Check } from 'lucide-react';

const DataCard = ({ title, tag, meta = [], description, icon: Icon, actions }) => {
    const [copiedLabel, setCopiedLabel] = useState(null);

    const handleCopy = async (value, label) => {
        if (!value || value === '—') return;
        try {
            await navigator.clipboard.writeText(value);
            setCopiedLabel(label);
            setTimeout(() => setCopiedLabel(null), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <div className="rounded-2xl border border-slate-200 bg-white/90 backdrop-blur p-4 shadow-sm hover:shadow-md transition relative overflow-hidden">
            <div className="absolute inset-0 pointer-events-none bg-gradient-to-br from-primary-50/50 via-transparent to-white" />
            <div className="relative flex items-start justify-between gap-3">
                <div className="flex items-start gap-3">
                    {Icon && (
                        <div className="h-10 w-10 rounded-xl bg-primary-50 text-primary-700 grid place-content-center shadow-inner">
                            <Icon className="h-5 w-5" />
                        </div>
                    )}
                    <div>
                        <div className="text-base font-semibold text-slate-900">{title}</div>
                        {description && (
                            <p className="mt-1 text-sm text-slate-600 break-all">
                                {typeof description === 'string' ? description : JSON.stringify(description)}
                            </p>
                        )}
                    </div>
                </div>
                {tag && (
                    <span
                        className={clsx(
                            'text-xs font-semibold px-2 py-1 rounded-full border',
                            tag === 'Active'
                                ? 'text-emerald-700 bg-emerald-50 border-emerald-100'
                                : 'text-amber-700 bg-amber-50 border-amber-100'
                        )}
                    >
                        {tag}
                    </span>
                )}
            </div>
            <dl className="relative mt-3 grid grid-cols-1 gap-2 text-sm text-slate-600">
                {meta.map(({ label, value, copyable }) => (
                    <div key={label} className="flex items-center justify-between gap-2">
                        <dt className="text-slate-500">{label}</dt>
                        <dd className="text-right text-slate-800 break-all flex items-center gap-1.5">
                            <span className="break-all">{value ?? '—'}</span>
                            {copyable && value && value !== '—' && (
                                <button
                                    onClick={() => handleCopy(value, label)}
                                    className="flex-shrink-0 p-1 rounded hover:bg-slate-100 text-slate-500 hover:text-slate-700 transition"
                                    title="Copy to clipboard"
                                >
                                    {copiedLabel === label ? (
                                        <Check className="h-3.5 w-3.5 text-emerald-600" />
                                    ) : (
                                        <Copy className="h-3.5 w-3.5" />
                                    )}
                                </button>
                            )}
                        </dd>
                    </div>
                ))}
            </dl>
            {actions && <div className="relative">{actions}</div>}
        </div>
    );
};

export default DataCard;
